import styled from 'styled-components'
import { LabelBold } from '../../../design-system/typography'
import { IconButton } from '../../../design-system/utils'

export const DetailsCard = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 475px;
  box-shadow: ${(p) => p.theme.boxShadow};
  background: ${(p) => p.theme.colors.white};
  z-index: 20;
  overflow: scroll;
  padding: ${(p) =>
    `${p.theme.spacing.xl} ${p.theme.spacing.md} ${p.theme.spacing.md}`};
`

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${(p) => p.theme.spacing.md};
  right: ${(p) => p.theme.spacing.md};
`

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: ${(p) => p.theme.spacing.md};
`

export const UserDataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: ${(p) => p.theme.spacing.sm};
  grid-column-gap: ${(p) => p.theme.spacing.xs};
  text-overflow: ellipsis;
  margin-bottom: ${(p) => p.theme.spacing.md};

  > p {
    overflow: hidden;
  }
`

export const AdminLabel = styled(LabelBold)`
  position: absolute;
  bottom: -15px;
`

export const ButtonsWrapper = styled.div`
  margin-top: ${(p) => p.theme.spacing.md};
  display: flex;
  justify-content: flex-end;

  > button {
    margin-left: ${(p) => p.theme.spacing.sm};
  }
`
